import React, {ReactNode, useState} from 'react';
import toggleArrayMember from "@Array/toggleArrayMember";
import filterArrayByKey from "@Array/filterArrayByKey";
import IconCheckmark from "@Icons/IconCheckmark";
import {useToggle} from "@Hooks/dispatch/useToggle";

interface MultiSelectFieldProps {
    options: any[],
    selected: any[],
    value?: string | number,
    label?: string | number,
    handler: (value: any) => void,
    placeholder?: string,
    className?: string,
    children: ReactNode[],
}

function MultiSelectField(props: MultiSelectFieldProps) {
    const {
        options,
        value = "value",
        label = "label",
        handler,
        selected,
        placeholder = "",
        className = "gb--input-standalone",
        children,
    } = props

    const [filtered, setFiltered] = useState([])
    const [inputValue, setInputValue] = useState("")
    const suggestions = filtered.length ? filtered : options
    const visible = useToggle()

    /**
     * Updates input value to keep state persistent if user focuses out
     * @param value {string}
     */
    const updateInputValue = ({target: {value}}) => {
        setInputValue(value)
        setFiltered(filterArrayByKey(options, "name", value))
    }

    const resetInputValues = () => {
        setInputValue('')
        setFiltered([])
        visible.onChange()
    }

    const handleClick = (suggestion) => () => {
        toggleArrayMember(handler, selected, suggestion[value], true)
        resetInputValues()
    }

    if (!visible.value) {
        return (
            <div
                id="stationSelect"
                className="gb--input-standalone"
                onClick={visible.onChange}
            >
                {children.length
                    ? children
                    : <span style={{color: "#757575"}}>{placeholder}</span>}
            </div>
        )
    }

    return (
        <div className="gb--suggestions-container" onMouseLeave={visible.onChange}>
            <input
                autoFocus
                className={className}
                placeholder={placeholder}
                onChange={updateInputValue}
                value={inputValue}
            />
            <div className="gb--autocomplete-suggestions">
                {suggestions.map((suggestion) => {
                    const selectedItem = selected.includes(suggestion[value]);

                    return (
                        <span
                            onClick={handleClick(suggestion)}
                            className={`gb--row ${selectedItem ? 'gb--suggestion-highlight' : ''}`}
                            key={suggestion[value]}
                        >
                            {selectedItem && <IconCheckmark/>}
                            {suggestion[label]}
                        </span>
                    )
                })}
            </div>
        </div>
    );
}

export default MultiSelectField;